import React from 'react';
import { useNavigate } from 'react-router-dom';

const ListingRowCard = ({ listing }) => {
  const { id, image, name, description, url, location, category } = listing;
  const navigate = useNavigate();

  const handleCardClick = () => {
    navigate(`/listing/${id}`);
  };

  return (
    <div 
      onClick={handleCardClick}
      className={`bg-white rounded-xl shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300 cursor-pointer transform hover:scale-101 relative ${listing.isBoosted ? 'ring-1 ring-yellow-400' : ''}`}
    >
      <div className="p-6 flex-1">
        {/* Boosted tag - updated to be smaller and not bold */}
        {listing.isBoosted && (
          <div className="absolute top-2 right-2 bg-yellow-400 text-[10px] px-2 py-1 rounded text-gray-800">
            FEATURED
          </div>
        )}
        
        <div className="flex items-center mb-4">
          {/* Only render image container if image URL exists */}
          {image && (
            <div className="h-12 w-12 flex-shrink-0 rounded-full overflow-hidden bg-gray-100 flex items-center justify-center mr-4">
              <img 
                src={image} 
                alt={`${name} logo`}
                className="h-12 w-12 object-cover"
                onError={(e) => {
                  e.target.parentElement.style.display = 'none';
                }}
              />
            </div>
          )}
          <h3 className="text-xl font-semibold text-gray-800 truncate">{name}</h3>
        </div>
        
        <p className="text-gray-600 mb-3">
          {description && description.length > 180 
            ? `${description.substr(0, 180).trim()}...` 
            : description}
        </p>
        
        <div className="flex flex-wrap items-center justify-between pt-2 border-t border-gray-100">
          <div className="flex flex-wrap">
            {location && (
              <div className="flex items-center text-gray-500 text-sm mr-6">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                <span>{location}</span>
              </div>
            )}
            {category && (
              <div className="flex items-center text-gray-500 text-sm">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
                </svg>
                <span>{category}</span>
              </div>
            )}
          </div>
          
          <div onClick={e => e.stopPropagation()}>
            <a 
              href={url}
              target="_blank"
              rel="noopener noreferrer"
              className="text-red-600 hover:text-red-800 font-medium text-sm flex items-center"
              onClick={(e) => {
                e.stopPropagation();
                window.open(url, '_blank', 'noopener,noreferrer');
              }}
            >
              Visit Website
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 ml-1 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(ListingRowCard);
